import numeral from 'numeral';

export default function (amount) {
    let value = numeral(amount);

    if(amount > 100000000){
        return value.divide(1000000).format('$0,0') + ' MM de pesos';
    }


    return value.format('$0,0') + ' pesos';
}


// WEBPACK FOOTER //
// ./resources/assets/js/Methods/MoneyFormatter.js